import { MaterialIcons } from '@expo/vector-icons';
import * as React from 'react';
import { TouchableOpacity } from 'react-native';
import { RegularText, Row, SlideUpModal } from 'src/components';
import { AppColors } from 'src/themes/Colors';
import { metrics, pixelScaler } from 'src/themes/Metrics';
import { DropdownType } from 'src/types/types';

interface Props {
  label: string;
  data: DropdownType[];
  value?: DropdownType;
  onChange(val: any): void;
  disabled?: boolean;
}

export const SortDropdown = ({ label, data, value, onChange, disabled }: Props) => {
  const [isVisible, setVisible] = React.useState(false);

  const handlePress = () => setVisible(true);

  const handleClose = () => setVisible(false);

  return (
    <Row middle>
      <RegularText color={AppColors.gray} fontSize="medium" textLang={label} />
      <TouchableOpacity
        style={{
          marginLeft: metrics.medium,
          borderWidth: 1,
          borderColor: AppColors.border,
          borderRadius: metrics.borderRadius,
          backgroundColor: AppColors.backgroundColor,
          padding: metrics.medium,
          flexDirection: 'row',
          minWidth: pixelScaler(130),
          justifyContent: 'space-between',
        }}
        disabled={disabled}
        activeOpacity={0.8}
        onPress={handlePress}>
        <RegularText>{value?.label}</RegularText>

        <MaterialIcons size={pixelScaler(18)} name="keyboard-arrow-down" />
      </TouchableOpacity>
      <SlideUpModal
        value={value}
        onPress={onChange}
        label={label}
        isVisible={isVisible}
        data={data}
        onClose={handleClose}
      />
    </Row>
  );
};
